<template>
  <div class="mobile-case">
    <!-- 案例分类 -->
    <div class="category-list">
      <div
        v-for="(item, index) in categories"
        :key="index"
        class="category-item"
        :class="{ active: currentCategory === item.id }"
        @click="handleCategoryChange(item.id)"
      >
        {{ item.title }}
      </div>
    </div>

    <!-- 案例列表 -->
    <div class="case-list">
      <div
        v-for="(item, index) in caseList"
        :key="index"
        class="case-item"
        @click="goToDetail(item)"
      >
        <div class="case-image">
          <img :src="item.image" :alt="item.title">
          <div class="case-tag" v-if="item.tag">{{ item.tag }}</div>
        </div>
        <div class="case-info">
          <div class="title">{{ item.title }}</div>
          <div class="desc">{{ item.description }}</div>
          <div class="meta">
            <span class="time">{{ item.createTime }}</span>
            <span class="views">
              <i class="el-icon-view"></i>
              {{ item.views }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 加载更多 -->
    <div class="load-more" v-if="hasMore" @click="loadMore">
      <span v-if="!loading">加载更多</span>
      <span v-else>加载中...</span>
    </div>
  </div>
</template>

<script>
import { articleList } from '@/api/index'

export default {
  name: 'MobileCase',
  data() {
    return {
      categories: [],
      currentCategory: null,
      caseList: [],
      allCases: [], // 存储所有案例
      page: 1,
      pageSize: 10,
      hasMore: true,
      loading: false
    }
  },
  created() {
    this.getCategories()
  },
  methods: {
    getCategories() {
      articleList({ classify_id: 7 }).then(res => {
        if (res.code === 200) {
          this.categories = res.data.rows || []
          if (this.categories.length > 0) {
            this.currentCategory = this.categories[0].id
            this.getCases()
          }
        }
      })
    },
    getCases() {
      this.loading = true
      articleList({
        classify_id: 7
      }).then(res => {
        if (res.code === 200) {
          this.allCases = res.data.rows || []
          this.filterCases()
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    filterCases() {
      if (this.currentCategory) {
        this.caseList = this.allCases.filter(item => item.id === this.currentCategory)
      } else {
        this.caseList = this.allCases
      }
    },
    handleCategoryChange(categoryId) {
      this.currentCategory = categoryId
      this.filterCases()
    },
    loadMore() {
      if (this.loading) return
      this.page++
      this.getCases()
    },
    goToDetail(item) {
      this.$router.push(`/newsDetail?classify_id=7&id=${item.id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-case {
  padding: 15px;
}

.category-list {
  display: flex;
  overflow-x: auto;
  margin-bottom: 15px;
  padding-bottom: 10px;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  .category-item {
    flex-shrink: 0;
    padding: 8px 15px;
    margin-right: 10px;
    background: #f5f5f5;
    border-radius: 20px;
    font-size: 14px;
    color: #666;
    white-space: nowrap;

    &.active {
      background: #2c9dcf;
      color: #fff;
    }
  }
}

.case-list {
  .case-item {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 15px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);

    .case-image {
      position: relative;
      width: 100%;
      height: 200px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .case-tag {
        position: absolute;
        top: 10px;
        right: 10px;
        padding: 4px 8px;
        background: rgba(44, 157, 207, 0.9);
        color: #fff;
        font-size: 12px;
        border-radius: 4px;
      }
    }

    .case-info {
      padding: 15px;

      .title {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin-bottom: 8px;
      }

      .desc {
        font-size: 14px;
        color: #666;
        line-height: 1.4;
        margin-bottom: 10px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }

      .meta {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 12px;
        color: #999;

        .views {
          display: flex;
          align-items: center;

          i {
            margin-right: 4px;
          }
        }
      }
    }
  }
}

.load-more {
  text-align: center;
  padding: 15px 0;
  color: #666;
  font-size: 14px;
}
</style>
